import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getTheme from '../MuiTheme';

var LLTextField = /*#__PURE__*/function (_Component) {
  _inherits(LLTextField, _Component);

  var _super = _createSuper(LLTextField);

  function LLTextField() {
    _classCallCheck(this, LLTextField);

    return _super.apply(this, arguments);
  }

  _createClass(LLTextField, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TextField, _extends({
        floatingLabelText: this.props.placeholder
      }, this.props, {
        placeholder: ""
      }));
    }
  }]);

  return LLTextField;
}(Component);

_defineProperty(LLTextField, "propTypes", {
  placeholder: PropTypes.string
});

_defineProperty(LLTextField, "defaultProps", {
  type: null,
  style: {},
  value: '',
  onChange: null,
  id: null
});

export { LLTextField as default };